import { Alert, AlertLink, Stack } from 'react-bootstrap';
import { AnnouncementType, IAnnouncementModel } from '../../../interfaces/IAnnoucementModel';
import { useEffect, useState } from 'react';

import { AnnouncementOverlay } from './AnnouncementOverlay';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { showErrorToast } from '../../../shared/ToastUtils';
import { useUserAcknowledgeAnnouncement } from './useUserAcknowledgeAnnouncement';

interface IAnnouncementProps {
    announcement: IAnnouncementModel;
    onRemoveAnnouncement: (guid: string) => void;
}

export function AnnouncementDetail({ announcement, onRemoveAnnouncement }: IAnnouncementProps) {
    const [showAnnouncement, setShowAnnouncement] = useState<boolean>(false);

    const acknowledgeMutation = useUserAcknowledgeAnnouncement();

    const acknowledgeAnnouncement = (announcementGuid: string) => {
        if (announcement.announcementTypeId === AnnouncementType.Public) {
            onRemoveAnnouncement(announcementGuid);
        } else {
            acknowledgeMutation
                .mutateAsync(announcementGuid)
                .then(() => {
                    onRemoveAnnouncement(announcementGuid);
                    handleHideAnnouncement();
                })
                .catch(() => showErrorToast('Failed to acknowledge announcement'));
        }
    };

    const handleHideAnnouncement = () => {
        setShowAnnouncement(false);
    };

    const handleCloseAnnouncement = () => {
        announcement?.guid ? acknowledgeAnnouncement(announcement?.guid) : handleHideAnnouncement();
    };

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        const url = LocalRoutes.Announcement.replace(
            ':announcementContentGuid',
            announcement?.guid || ''
        );
        window.open(url, '_blank')?.focus;
    };

    useEffect(() => {
        let pathToMatch = location.pathname.includes('/zone/')
            ? location.pathname.replace(/\/zone\/[a-f0-9-]+/, '')
            : location.pathname;
        if (pathToMatch === '') {
            pathToMatch = '/';
        }

        const show =
            (announcement?.announcementTypeId === AnnouncementType.Page &&
                announcement.routeKey === pathToMatch) ||
            announcement?.announcementTypeId !== AnnouncementType.Page;

        setShowAnnouncement(show);
    }, [location.pathname, announcement]);

    const showGlobalOverlay =
        announcement.isBlocking &&
        (announcement.announcementTypeId === AnnouncementType.Global ||
            announcement.announcementTypeId === AnnouncementType.Public);

    const alert = (
        <Alert
            key={announcement.guid}
            variant={announcement?.variant ?? 'info'}
            onClose={handleCloseAnnouncement}
            dismissible
            show={showAnnouncement}
            transition={true}
            style={{
                ...(announcement.announcementTypeId === AnnouncementType.Public
                    ? { zIndex: 100 }
                    : {}),
            }}
        >
            <Stack
                direction="horizontal"
                gap={3}
                style={{ alignItems: 'center', flexWrap: 'nowrap', paddingRight: '3em' }}
            >
                <Alert.Heading>
                    <Stack direction="horizontal" gap={2}>
                        {announcement.icon && <i className={announcement.icon}></i>}
                        <span className="nowrap">{announcement?.title}</span>
                    </Stack>
                </Alert.Heading>
                <span>{announcement?.text}</span>
                {announcement?.pageMarkup && (
                    <AlertLink href="#" onClick={handleLinkClick}>
                        See Details
                    </AlertLink>
                )}
                <AlertLink href="#" onClick={handleCloseAnnouncement}>
                    Dismiss
                </AlertLink>
            </Stack>
        </Alert>
    );

    return (
        <>
            {showGlobalOverlay ? (
                <>
                    <AnnouncementOverlay>{alert}</AnnouncementOverlay>
                    <div className="sticky-top">{alert}</div>
                </>
            ) : (
                <div className="sticky-top">{alert}</div>
            )}
        </>
    );
}
